<script setup lang="ts">
/**
 * Message persistant dans la page (hors ligne, alerte d'enveloppe, échéance en retard).
 * Fond neutre, icône colorée et texte explicite ; une action de résolution si possible.
 * L'action utilise la variante `ghost` (fond blanc), lisible sur le fond `surface`.
 */
import type { IconName } from '../icons/registry'
import Icon from './Icon.vue'

withDefaults(
  defineProps<{ tone?: 'info' | 'warn' | 'danger' | 'offline'; title: string; message?: string }>(),
  { tone: 'info', message: undefined },
)

const LOOK: Record<'info' | 'warn' | 'danger' | 'offline', { icon: IconName; tone: string }> = {
  info: { icon: 'info', tone: 'text-accent-strong' },
  warn: { icon: 'alert', tone: 'text-warn' },
  danger: { icon: 'alert', tone: 'text-danger' },
  offline: { icon: 'offline', tone: 'text-ink-muted' },
}
</script>

<template>
  <div
    class="flex items-start gap-3 rounded-control bg-surface px-4 py-3"
    :role="tone === 'danger' || tone === 'warn' ? 'alert' : 'status'"
  >
    <Icon :name="LOOK[tone].icon" :class="['mt-0.5', LOOK[tone].tone]" />
    <div class="flex flex-1 flex-col gap-0.5">
      <p class="text-label text-ink">{{ title }}</p>
      <p v-if="message" class="text-caption text-ink-muted">{{ message }}</p>
      <div v-if="$slots.action" class="mt-2"><slot name="action" /></div>
    </div>
  </div>
</template>
